import { render } from "./DomainOwnershipValidation.vue?vue&type=template&id=7cfa2118&scoped=true"
import script from "./DomainOwnershipValidation.vue?vue&type=script&lang=ts"
export * from "./DomainOwnershipValidation.vue?vue&type=script&lang=ts"

import "./DomainOwnershipValidation.vue?vue&type=style&index=0&id=7cfa2118&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7cfa2118"

export default script